export const lw = (num: number | string) => {
  return `calc(100vw / 1200 * ${num})`
}

export const mlw = (num: number | string) => {
  return `calc(100vw / 375 * ${num})`
}